export default __webpack_public_path__ + "static/media/mb11.a846a259.JPG";